<template>
  <div class="historicla">
    <!-- 打印处方 -->
    <div class="mask1" style="display: none">
      <div class="prescription_img_box" style="overflow: scroll">
        <viewer>
          <section ref="print" id="jqImg">
            <img
              v-for="(item, i) in imgUrl"
              :key="i"
              :src="item"
              class="pointer"
            />
          </section>
        </viewer>
      </div>
    </div>
    <!--打印单个历史处方>-->
    <div style="display: none">
      <section ref="printOne">
        <div v-if="showPrint">
          <dom-print
            :InquiryId="InquiryId"
            @afterPrint="afterPrint"
            @beforPrint="beforPrint"
          ></dom-print>
        </div>
      </section>
    </div>
    <!-- 历史处方-->
    <div class="flex2">
      <div class="flex2">
        <div class="fixed_width72">患者姓名：</div>
        <input
          type="text"
          v-model="filterCondition.name"
          style="width: 180px"
        />
      </div>
      <div class="flex2">
        <div class="fixed_width72">手机号码：</div>
        <input
          type="text"
          v-model="filterCondition.mobile"
          style="width: 180px"
        />
      </div>

      <!-- <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">处方类型：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.selectModel"
          style="width:180px;"
        >
          <option>全部</option>
          <option>西药处方</option>
          <option>中药处方</option>
        </select>
      </div> -->
      <div class="flex2">
        <div class="fixed_width72">处方开具时间：</div>
        <Date-picker
          type="datetimerange"
          split-panels
          placeholder="选择日期"
          :value="filterCondition.createDate"
          style="width: 300px; margin-right: 34px"
          :editable="false"
          format="yyyy-MM-dd HH:mm:ss"
          @on-change="createDateChange"
        ></Date-picker>
      </div>
    </div>

    <div class="flex2 margin_top26">
      <div class="flex2">
        <div class="fixed_width72">药品名称：</div>
        <input
          type="text"
          v-model="filterCondition.DrugName"
          style="width: 180px"
        />
      </div>
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">审核状态：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.SignStatus"
          style="width: 180px"
        >
          <option value="">全部</option>
          <option value="1">待审方</option>
          <option value="2">已审方</option>
        </select>
      </div>
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">审核来源：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.OpenAuditChannel"
          style="width: 180px"
        >
          <option value="">全部</option>
          <option value="0">无</option>
          <option value="1">药店端</option>
          <option value="2">远程审方</option>
          <option value="3">第三方远程审方</option>
        </select>
      </div>
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">远程审方：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.OpenAuditStatus"
          style="width: 180px"
        >
          <option value="">全部</option>
          <option value="0">否</option>
          <option value="3">待药师审核</option>
          <option value="5">审核通过</option>
          <option value="99">审核不通过</option>
        </select>
      </div>
    </div>
    <div class="flex2 margin_top26">
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">审核药师：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.AuditName"
          style="width: 180px"
        >
          <option value="">全部</option>
          <option value="1">已签名</option>
          <option value="0">未签名</option>
        </select>
      </div>
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">调配：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.DispensName"
          style="width: 180px"
        >
          <option value="">全部</option>
          <option value="1">已签名</option>
          <option value="0">未签名</option>
        </select>
      </div>
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">复核/发药：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.ReviewName"
          style="width: 180px"
        >
          <option value="">全部</option>
          <option value="1">已签名</option>
          <option value="0">未签名</option>
        </select>
      </div>
      <div class="flex2" v-if="totalShop">
        <div class="fixed_width72">来源门店：</div>
        <!-- <input type="text" v-model="filterCondition.sourceName" style="width:180px;" /> -->
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.ShopId"
          style="width: 180px"
        >
          <option value="0">全部</option>
          <option
            :value="item.ShopId"
            v-for="(item, i) in childStoreList"
            :key="i"
          >
            {{ item.ShopName }}
          </option>
        </select>
      </div>
    </div>
    <div
      class="flex2 margin_top26 margin_bottom26"
      style="justify-content: end;"
    >
      <div class="inquiry_recording_search_btn pointer" @click="pressSearch">
        查询
      </div>
      <div class="print_btn pointer" @click="printInquiryImg">
        批量打印本页处方
      </div>
      <div class="print_btn pointer" @click="batchExport">批量导出图片</div>
    </div>
    <!-- <div class="margin_top26 margin_bottom26">
      <div class="flex2" style="margin-left:79%;">
        <div
          class="inquiry_recording_search_btn pointer"
          @click="pressSearch"
          @keyup.enter="pressSearch()"
        >查询</div>
        <div class="print_btn pointer" @click="printInquiryImg">批量打印本页处方</div>
      </div>
    </div>-->
    <!-- 查看处方 -->
    <div class="mask1" v-if="lookShop">
      <look-Prescription
        v-if="lookShop"
        @lookModule="closeModule"
        @noeModules="oneKeySignature"
        :InquiryId="InquiryId"
        v-watermark="{
          text: appMobilePhone,
          textColor: 'rgba(180, 180, 180, 0.3)',
        }"
      ></look-Prescription>
    </div>
    <!-- 一键签名 -->
    <div class="mask1" v-if="oneShop">
      <one-signature
        @noeModules="closeoneModule"
        :InquiryId="InquiryId"
        :PrescriptionStatus="PrescriptionStatus"
        :signaNum="signaNum"
      ></one-signature>
    </div>
    <Table
      :columns="tableColumns"
      :data="tableData"
      border
      style="margin-bottom: 20px"
      width="100%"
      @on-selection-change="selectChange"
    ></Table>
    <Page
      :total="PageTotal"
      :current="page"
      style="text-align: center"
      @on-change="pageChange"
      show-total
      show-elevator
    />
    <Modal
      v-model="modal5"
      title="确认远程审方？"
      width="300"
      class-name="vertical-center-modal"
    >
      <p>处方将发送给药师进行审核，</p>
      <p>提交后您将无法撤销。</p>
    </Modal>
  </div>
</template>

<script>
import {
  GetInquiryHistoryList,
  DownLoadToBase64,
  GetPicCodeByUrl,
  DownLoadOrderList,
  CreateDownLoadOrderList,
  PushToOpenPrescriptionSys,
} from "@/utils/api.js";
import domPrint from "@/components/domPrint";
import { getCookie } from "@/utils/common.js";
import lookPrescription from "@/components/lookPrescription";
import oneSignature from "@/components/onekeySignature";
import { Radio, Alert, Divider, Toast } from "iview";
// import "@/src/utils/jquery-1.4.4.min";
import "@/utils/jquery.jqprint-0.3";
import { printPrescriptionImg } from "@/utils/printImg.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
export default {
  props: {
    shopTypeChild: {
      type: String,
      default: false,
    },
    childStoreList: {
      default: false,
    },
  },

  components: {
    lookPrescription,
    oneSignature,
    domPrint,
  },
  data() {
    return {
      modal5: false,
      OpenTrialStatus: 0,
      signaNum: 0,
      PageTotal: 0, // 记录总条数
      page: 1,
      InquiryId: "",
      PrescriptionStatus: "",
      drugPage: 1,
      appMobilePhone: "",
      totalShop: false,
      lookShop: false,
      showPrint: false,
      oneShop: false,
      filterCondition: {
        // 筛选条件
        selectModel: "全部",
        createDate: ["", ""],
        name: "",
        mobile: "",
        ShopId: "0",
        DrugName: "",
        SignStatus: "",
        OpenAuditStatus: "",
        OpenAuditChannel: "",
        AuditName: "",
        DispensName: "",
        ReviewName: "",
      },
      tableColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "处方开具时间",
          key: "CreateDate",
          align: "center",
          width: 150,
          render: (h, params) => {
            var str = params.row.CreateDate;
            if (str.length > 10) {
              var strs = str.split("T")[0];
            } else {
              var strs = str;
            }
            return h("span", strs);
          },
        },
        {
          title: "患者姓名",
          key: "Name",
          align: "center",
          width: 120,
        },
        {
          title: "性别",
          key: "Sex",
          align: "center",
          width: "80",
          render: (h, params) => {
            let sexChina = params.row.Sex == 1 ? "男" : "女";
            return h("span", sexChina);
          },
        },
        {
          title: "年龄",
          key: "AgeStr",
          align: "center",
          width: 120,
        },
        {
          title: "手机号",
          key: "Mobilephone",
          align: "center",
          width: 120,
        },
        {
          title: "诊断",
          key: "Diagnosis",
          align: "center",
          width: 120,
        },

        {
          title: "处方类型",
          key: "type",
          align: "center",
          width: 120,
          render: (h, params) => {
            let typeT = "";
            if (params.row.CNDrugsType == 3) {
              typeT = "中药处方";
            } else {
              typeT = "西药处方";
            }
            return h("span", typeT);
          },
        },
        {
          title: "处方医生",
          key: "DoctorName",
          align: "center",
          width: 120,
        },
        {
          title: "审核来源",
          key: "OpenAuditChannelDesc",
          align: "center",
          width: 120,
        },
        {
          title: "审核状态",
          key: "AuditStatusDesc",
          align: "center",
          width: 120,
        },
        {
          title: "审核药师",
          key: "AuditName",
          align: "center",
          width: 120,
        },
        {
          title: "调配",
          key: "DispensName",
          align: "center",
          width: 120,
        },
        {
          title: "复核/发药",
          key: "ReviewName",
          align: "center",
          width: 120,
        },
        {
          title: "远程审方",
          key: "OpenAuditStatusDesc",
          align: "center",
          width: 120,
          // render: (h, params) => {
          //   //判断是否有开通远程审方
          //  let OpenTrialStatus = getCookie('OpenTrialStatus')
          //  if(OpenTrialStatus)
          //   // let tmpStr = "";
          //   // if (params.row.AuditStatus == null || params.row.AuditStatus == 0) {
          //   //   tmpStr = "否";
          //   // } else {
          //   //   tmpStr = "是";
          //   // }
          //   // return h("span", tmpStr);
          // },
        },
        // {
        //   title: "药师审核",
        //   key: "IsPharSign",
        //   align: "center",
        //   render: (h, params) => {
        //     let tmpStr = "";
        //     if (!params.row.PharAuditNameUrl) {
        //       tmpStr = "待审方";
        //     } else {
        //       tmpStr = "已审方";
        //     }
        //     return h(
        //       "span",
        //       {
        //         style: {
        //           color: params.row.IsPharSign == false ? "#DB0E0E" : "#515a6e",
        //         },
        //       },
        //       tmpStr
        //     );
        //   },
        // },
        // {
        //   title: "远程审方",
        //   key: "AuditStatus",
        //   align: "center",
        //   render: (h, params) => {
        //     let tmpStr = "";
        //     if (params.row.AuditStatus == null || params.row.AuditStatus == 0) {
        //       tmpStr = "否";
        //     } else {
        //       tmpStr = "是";
        //     }
        //     return h("span", tmpStr);
        //   },
        // },
        {
          title: "操作",
          key: "doit",
          align: "center",
          fixed: "right",
          width: 120,
          render: (h, params) => {
            let OpenTrialStatus = getCookie("OpenTrialStatus");
            let arr = [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.lookPrescription(params.row);
                    },
                  },
                },
                "查看处方"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.toRemote(params.row);
                    },
                  },
                  directives: [
                    {
                      name: "show",
                      value:
                        OpenTrialStatus == 1 &&
                        !params.row.OpenAuditStatus &&
                        !params.row.PharAuditNameUrl, // 设置为 false 隐藏，true 显示
                    },
                  ],
                },
                "远程审方"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.printPrescriptionJq(params.row);
                    },
                  },
                },
                `打印处方`
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.savePrescription(params.row);
                    },
                  },
                },
                "保存处方"
              ),
            ];
            return h("div", arr);
          },
        },
      ],
      selectedRows: new Map(),
      tableData: [],
      batchUrl: [],
      imgUrl: [],
      DownLoadKey: "",
    };
  },
  methods: {
    selectChange(selection) {
      // 获取当前页面所有数据的 ID
      const currentPageIds = new Set(
        this.tableData.map((item) => item.LoInquiryId)
      );

      // 1. 从 selectedRows 中找出当前页面之前选中的项
      const previousCurrentPageSelected = new Set();
      for (let [id] of this.selectedRows) {
        if (currentPageIds.has(id)) {
          previousCurrentPageSelected.add(id);
        }
      }

      // 2. 找出当前页面新选中的项（在 selection 中但不在 previousCurrentPageSelected 中）
      const currentSelectedIds = new Set(
        selection.map((item) => item.LoInquiryId)
      );
      const newlySelected = selection.filter(
        (item) => !previousCurrentPageSelected.has(item.LoInquiryId)
      );

      // 3. 找出当前页面取消选中的项（在 previousCurrentPageSelected 中但不在 current selection 中）
      const deselected = Array.from(previousCurrentPageSelected)
        .filter((id) => !currentSelectedIds.has(id))
        .map((id) => this.selectedRows.get(id)); // 获取完整的行数据

      // 4. 处理新选中的项：添加到 selectedRows
      newlySelected.forEach((row) => {
        this.selectedRows.set(row.LoInquiryId, row);
        console.log("新增选中项:", row);
      });

      // 5. 处理取消选中的项：从 selectedRows 中删除
      deselected.forEach((row) => {
        this.selectedRows.delete(row.LoInquiryId);
        console.log("取消选中项:", row);
      });

      console.log(
        "当前所有选中的行数据:",
        Array.from(this.selectedRows.values())
      );
    },
    async exportSelectedImagesAsZip() {
      const selectedRows = Array.from(this.selectedRows.values());

      if (selectedRows.length === 0) {
        this.$Modal.warning({
          title: "提示",
          content: "请先选择要导出的处方图片！",
        });
        return;
      }

      try {
        // 创建 ZIP 文件
        const zip = new JSZip();
        let phone = localStorage.getItem("app_mobile");
        // 创建一个文件夹来存放图片
        const imgFolder = zip.folder(phone);

        // 下载所有选中的图片
        const downloadPromises = selectedRows.map(async (row, index) => {
          if (row.OrderFileUrl) {
            try {
              // 下载图片
              const response = await fetch(row.OrderFileUrl);
              const blob = await response.blob();

              // 获取文件扩展名
              const urlParts = row.OrderFileUrl.split(".");
              const extension =
                urlParts[urlParts.length - 1].split("?")[0] || "jpg";

              // 添加到 ZIP 文件中
              imgFolder.file(`${row.LoInquiryId}.${extension}`, blob);
            } catch (error) {
              console.error(`下载图片失败: ${row.OrderFileUrl}`, error);
            }
          }
        });

        // 等待所有图片下载完成
        await Promise.all(downloadPromises);

        // 生成 ZIP 文件并下载
        const content = await zip.generateAsync({ type: "blob" });
        // 使用 dayjs 生成格式化的日期时间
        const formattedDate = dayjs().format("YYYYMMDD_HHmmss");
        saveAs(content, `处方图片_导出日期_${formattedDate}.zip`);

        this.$Message.success("图片导出成功！");
      } catch (error) {
        console.error("导出失败:", error);
        this.$Message.error("图片导出失败！");
      }
    },

    // 导出所有当前页面的图片为 ZIP 文件
    async exportSelectedImagesAsZipWithProgress() {
      const selectedRows = this.getAllSelectedRows();

      if (selectedRows.length === 0) {
        this.$Modal.warning({
          title: "提示",
          content: "请先选择要导出的处方图片！",
        });
        return;
      }

      // 显示进度条
      const loading = this.$Message.loading({
        content: "正在准备导出...",
        duration: 0,
      });

      try {
        const zip = new JSZip();
        const imgFolder = zip.folder("处方图片");

        // 更新进度
        let completed = 0;
        const total = selectedRows.length;

        const downloadPromises = selectedRows.map(async (row, index) => {
          if (row.OrderFileUrl) {
            try {
              loading(); // 关闭之前的loading
              const newLoading = this.$Message.loading({
                content: `正在下载图片 ${index + 1}/${total}...`,
                duration: 0,
              });

              const response = await fetch(row.OrderFileUrl);
              const blob = await response.blob();

              const urlParts = row.OrderFileUrl.split(".");
              const extension =
                urlParts[urlParts.length - 1].split("?")[0] || "jpg";

              const fileName = `处方_${row.Name || "未知"}_${
                row.LoInquiryId
              }.${extension}`;
              imgFolder.file(fileName, blob);

              newLoading(); // 关闭当前loading
              completed++;
            } catch (error) {
              console.error(`下载图片失败: ${row.OrderFileUrl}`, error);
            }
          }
        });

        await Promise.all(downloadPromises);

        // 生成 ZIP 文件
        const zipLoading = this.$Message.loading({
          content: "正在生成ZIP文件...",
          duration: 0,
        });

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `处方图片_${new Date().getTime()}.zip`);

        zipLoading(); // 关闭ZIP生成loading
        this.$Message.success("图片导出成功！");
      } catch (error) {
        console.error("导出失败:", error);
        this.$Message.error("图片导出失败！");
      }
    },
    // 获取所有选中的行数据
    getAllSelectedRows() {
      return Array.from(this.selectedRows.values());
    },
    // 清空所有选中项
    clearAllSelectedRows() {
      this.selectedRows.clear();
      // 如果需要清除表格的视觉选中状态，可能需要额外处理
    },
    //去第三方远程审方
    toRemote(item) {
      this.$Modal.confirm({
        title: "确认远程审方?",
        content: "<p>处方将发送给药师进行审核，</p><p>提交后您将无法撤销。</p>",
        okText: "确认提交",
        cancelText: "取消",
        onOk: () => {
          PushToOpenPrescriptionSys({ LoInquiryId: item.LoInquiryId }).then(
            (res) => {
              if (res.code == 1) {
                this.$Message.success(res.msg);
              } else {
                this.$Message.error(res.msg, 3);
              }
              this.getHistory();
            }
          );
        },
      });
    },
    //轮询等待下载
    loadingDown() {
      DownLoadOrderList({ DownLoadKey: this.DownLoadKey }).then((res) => {
        if (res.code == 1) {
          console.log(res);
          window.open(process.env.VUE_APP_RELOAD + res.data);
          // window.open(res.data);
        } else {
          setTimeout(() => {
            this.loadingDown();
          }, 3000);
        }
      });
    },
    //批量导出
    batchExport() {
      const selectedRows = this.getAllSelectedRows();
      if (selectedRows.length > 0) {
        this.exportSelectedImagesAsZip();
        return;
      }

      CreateDownLoadOrderList({
        StartTime: this.filterCondition.createDate[0],
        EndTime: this.filterCondition.createDate[1],
        Name: this.filterCondition.name,
        Mobilephone: this.filterCondition.mobile,
        ShopId: this.filterCondition.ShopId, //来源门店this.filterCondition.sourceName
        Status: 5,
        ModeType: "",
        DrugName: this.filterCondition.DrugName,
        PageIndex: 1,
        PageSize: 100000,
        ...this.filterCondition,
      }).then((res) => {
        if (res.code == 1) {
          // this.$Modal.warning({
          //   title: "提示",
          //   content: "批量导出图片生成中",
          // });
          this.$Notice.warning({
            title: "提示",
            desc: "批量导出图片生成中",
          });
          this.DownLoadKey = res.data;
          this.loadingDown();
        } else {
          this.$Modal.warning({
            title: "提示",
            content: res.msg,
          });
        }
      });
    },
    //一键签名
    oneKeySignature(e) {
      this.signaNum = e;
      this.lookShop = !this.lookShop;
      this.oneShop = !this.oneShop;
    },
    closeoneModule() {
      this.oneShop = !this.oneShop;
      this.lookShop = !this.lookShop;
    },
    //关闭弹框
    closeModule() {
      this.lookShop = !this.lookShop;
    },
    //查看处方
    lookPrescription(row) {
      this.InquiryId = row.LoInquiryId;
      this.PrescriptionStatus = row.PrescriptionStatus;
      this.lookShop = !this.lookShop;
    },
    //单个打印处方
    printPrescription(row) {
      if (row.OrderFileUrl) {
        var url = row.OrderFileUrl;
        this.imgUrl = [url];
        console.log(this.imgUrl);
        let t1 = setTimeout((res) => {
          this.$print(this.$refs.print); // 使用
          window.clearInterval(t1);
        });
      } else {
        this.$Modal.warning({
          title: "提示",
          content: "该历史处方无处方图片,打印失败！",
        });
      }
    },
    //单个打印图片jq
    printPrescriptionJq(row) {
      if (row.OrderFileUrl) {
        const imgSrc = row.OrderFileUrl;
        printPrescriptionImg(imgSrc);
      } else {
        this.$Modal.warning({
          title: "提示",
          content: "该历史处方无处方图片,打印失败！",
        });
      }
      // if (!row.OpenAuditStatus) {
      //   if (row.OrderFileUrl) {
      //     this.InquiryId = row.LoInquiryId;
      //     this.showPrint = true;
      //   } else {
      //     this.$Modal.warning({
      //       title: "提示",
      //       content: "该历史处方无处方图片,打印失败！",
      //     });
      //   }
      // }else{
      //   //w

      //   const imgSrc = row.OrderFileUrl;
      //   printPrescriptionImg(imgSrc)
      // }
    },
    //获取完数据之后打印处方
    afterPrint() {
      let t1 = setTimeout((res) => {
        this.$print(this.$refs.printOne); // 使用
        this.showPrint = false;
        window.clearInterval(t1);
      });
    },
    //获取处方失败
    beforPrint() {
      this.showPrint = false;
    },
    //保存处方
    savePrescription(row) {
      var msg = {
        url: row.OrderFileUrl,
        id: row.InquiryId,
        base64: true,
      };
      this.$store.dispatch("downloads", msg);
    },
    // 批量打印处方
    printInquiryImg() {
      if (this.batchUrl[0] === undefined || this.batchUrl.length == 0) {
        this.$Modal.warning({
          title: "提示",
          content: "本页表格暂无数据，批量打印处方失败！！",
        });
        return false;
      }
      this.imgUrl = this.batchUrl;
      let t1 = setTimeout((res) => {
        // this.$print(this.$refs.print); // 使用
        $("#jqImg").jqprint({
          debug: false,
          importCSS: false,
          printContainer: true,
          operaSupport: false,
        });
        // window.clearInterval(t1);
      });
    },
    pageChange(i) {
      console.log(i);
      this.page = i;
      this.getHistory();
    },
    //选择日期触发条件
    createDateChange(value) {
      if (value && value.length === 2 && value[0] && value[1]) {
        // 开始日期设置为 00:00:00
        const startDate = value[0];
        // 结束日期设置为 23:59:59
        let endDate = value[1];
        if (value[1].includes("00:00:00")) {
          endDate = dayjs(value[1])
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        }

        this.filterCondition.createDate = [startDate, endDate];
      } else {
        this.filterCondition.createDate = value;
      }
    },
    //点击查询按钮
    pressSearch() {
      this.page = 1;
      this.getHistory();
    },
    //获取历史处方
    getHistory(type) {
      let msg = "";
      if (!type) {
        msg = this.$Message.loading({
          content: "加载中",
          duration: 0,
        });
      }

      let UserId = localStorage.getItem("app_mobile");
      let companyName = localStorage.getItem("companyName");
      let Token = localStorage.getItem("hToken");
      let ShopType = this.shopTypeChild;
      GetInquiryHistoryList({
        StartTime: this.filterCondition.createDate[0],
        EndTime: this.filterCondition.createDate[1],
        Name: this.filterCondition.name,
        Mobilephone: this.filterCondition.mobile,
        ShopId: this.filterCondition.ShopId, //来源门店this.filterCondition.sourceName
        Status: 5,
        ModeType: "",
        DrugName: this.filterCondition.DrugName,
        PageIndex: this.page,
        PageSize: 10,
        ...this.filterCondition,
      }).then((res) => {
        msg && setTimeout(msg, 17);
        if (res.code == 1) {
          this.tableData = [];
          this.batchUrl = [];
          this.PageTotal = res.data.total;
          // res.data.list[3]._checked = true;
          // res.data.list[3].OpenAuditStatus = 5
          res.data.list.map((item) => {
            // item.PharmacistStatus = 99;
            if (this.selectedRows.has(item.LoInquiryId)) {
              item._checked = true;
            }
            this.batchUrl.push(item.OrderFileUrl);
          });
          this.tableData = res.data.list;
        } else {
          this.$Modal.warning({
            title: "提示",
            content: res.msg,
          });
        }
        this.loading = false;
      });
    },
    weekTime() {
      const myDate = new Date();
      const year = myDate.getFullYear(); // 获取当前年份
      const month =
        myDate.getMonth() + 1 < 10
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
      const day =
        myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate(); // 获取当前日（1-31）
      // 日期格式：2019/07/29 - 2019/07/29
      const lastDate = new Date(new Date() - 6 * 24 * 60 * 60 * 1000);

      const lastYear = lastDate.getFullYear(); // 获取当前年份
      const lastMonth =
        lastDate.getMonth() + 1 < 10
          ? "0" + (lastDate.getMonth() + 1)
          : lastDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
      const lastDay =
        lastDate.getDate() < 0 ? "0" + lastDate.getDate() : lastDate.getDate(); // 获取当前日（1-31）
      this.$nextTick(() => {
        this.filterCondition.createDate = [
          `${lastYear}-${lastMonth}-${lastDay} 00:00:00`,
          `${year}-${month}-${day} 23:59:59`,
        ];
        console.error(this.filterCondition.createDate);
        this.getHistory(1);
      });
    },
  },
  mounted() {
    setTimeout((res) => {
      this.weekTime();
    });

    this.appMobilePhone = localStorage.getItem("app_mobile");
    this.OpenTrialStatus = getCookie("OpenTrialStatus");
    if (this.shopTypeChild == 0) {
      let comObg = {
        title: "来源门店",
        key: "CompanyName",
        align: "center",
        width: 120,
      };
      this.totalShop = true;
      this.tableColumns.splice(6, 0, comObg);
    } else {
      if (this.tableColumns.length == 10) {
        this.totalShop = false;
        this.tableColumns.splice(7, 1);
      }
    }
  },
  created() {
    // this.keyupEnter();
  },
};
</script>
<style lang="scss">
.print_btn {
  height: 28px;
  padding: 0 15px;
  background: #2f318b;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  color: white;
  line-height: 28px;
  margin-left: 20px;
}
.ivu-table-fixed-body {
  background-color: #ffffff;
}
</style>
<style lang="scss" scoped src="../scss/index.scss"></style>
